import angular from 'angular';
import { STATES } from '@mover-app/constants';
import { PackingSuppliesConfig } from './packing-supplies.config';

export const PackingSuppliesModule = angular
  .module(STATES.STEP_PACKING_SUPPLIES, [])
  .config(PackingSuppliesConfig);
